export default __webpack_public_path__ + "static/media/img_post6_5.4079a8f7.png";